import { ENUM__local_event } from '@/services/events/ENUM__local_event';
import { service_local_events } from '@/services/events/service_local_events';
import { store } from '@/state/store';
import { local_workspace_user_delete } from '@/state/workspace/user/local_workspace_user_delete';
import { local_workspace_user_upsert } from '@/state/workspace/user/local_workspace_user_upsert';
import { local_workspace_user_invitation_delete } from '@/state/workspace/user_invitation/local_workspace_user_invitation_delete';
import { local_workspace_user_invitation_upsert } from '@/state/workspace/user_invitation/local_workspace_user_invitation_upsert';
import { RequestViewerAction } from '@shared/common/_requests/request_viewer_action';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { DTOWorkspaceUserInvitation } from '@shared/dto/+workspace/workspace_user_invitation/dto_workspace_user_invitation';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../../_methods/add_socket_handler_client';
import { init_grid2d_possible_features_for_all_entities } from '../../_methods/init_grid2d_possible_features_for_all_entities';

export function add_socket_handlers_client_workspace_user() {
  add(ENE.WORKSPACE_USER_UPSERT, (items: DTO__workspace_user[]) => {
    store.dispatch(local_workspace_user_upsert(items));

    init_grid2d_possible_features_for_all_entities();
  });

  add(ENE.WORKSPACE_USER_ACTION_UPSERT, (items: RequestViewerAction[]) => {
    for (const item of items) {
      service_local_events.emit(ENUM__local_event.RESPONSE_VIEWER_ACTION_RECEIVED, item);
    }
  });

  add(ENE.WORKSPACE_USER_DELETE, (ids: string[]) => store.dispatch(local_workspace_user_delete(ids)));

  add(ENE.WORKSPACE_USER_INVITATION_UPSERT, (items: DTOWorkspaceUserInvitation[]) => {
    let user_id = store.getState().slice_user.user_id;

    store.dispatch(local_workspace_user_invitation_upsert({ invitations: items, user_id }));
  });

  add(ENE.WORKSPACE_USER_INVITATION_DELETE, (ids: string[]) => store.dispatch(local_workspace_user_invitation_delete(ids)));
}
